/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientEntity } from './ClientEntity';
import {
	ClientEntityFromJSON,
	ClientEntityFromJSONTyped,
	ClientEntityToJSON,
} from './ClientEntity';

/**
 * Payload of enumerated client organizations from search with pagination support
 * @export
 * @interface SearchClientsResponse
 */
export interface SearchClientsResponse {
	/**
	 *
	 * @type {Array<ClientEntity>}
	 * @memberof SearchClientsResponse
	 */
	items: Array<ClientEntity>;
	/**
	 * Continuation token for pagination to be used in subsequent search requests
	 * @type {string}
	 * @memberof SearchClientsResponse
	 */
	continuationToken?: string;
}

/**
 * Check if a given object implements the SearchClientsResponse interface.
 */
export function instanceOfSearchClientsResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'items' in value;

	return isInstance;
}

export function SearchClientsResponseFromJSON(json: any): SearchClientsResponse {
	return SearchClientsResponseFromJSONTyped(json, false);
}

export function SearchClientsResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SearchClientsResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		items: (json['items'] as Array<any>).map(ClientEntityFromJSON),
		continuationToken: !exists(json, 'continuationToken')
			? undefined
			: json['continuationToken'],
	};
}

export function SearchClientsResponseToJSON(value?: SearchClientsResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		items: (value.items as Array<any>).map(ClientEntityToJSON),
		continuationToken: value.continuationToken,
	};
}
